
import { defineComponent } from 'vue'

import { MobileNav } from '~/components/Layout'
import activeUserMixin from '~/mixins/activeUserMixin'
import AuthMixin from '~/mixins/authMixin'
import PortalMixin from '~/mixins/portalMixin'

import ControlPanelBaseMixin from '~/mixins/control-panel/ControlPanelBaseMixin'

import { stripTrailingSlash } from '~/utils/string'

import { ControlPanelRouteT } from '~/types/control-panel'

/**
 * Layout for control panel
 */
export default defineComponent({
  name: 'ControlPanelLayout',
  components: {
    MobileNav
  },
  head: {
    bodyAttrs: {
      class: 'antialiased stroke-2 min-h-screen bg-ink-400'
    }
  },
  meta: {
    auth: { strict: true }
  },
  middleware: ['restrictControlPanelAccess'],
  mixins: [AuthMixin, PortalMixin, ControlPanelBaseMixin, activeUserMixin],
  data() {
    return {
      showFeedbackModal: false,
      reRenderBreadcrumbs: false
    }
  },
  watch: {
    '$route.path': {
      handler() {
        this.updateBreadcrumbs()
      }
    }
  },
  async fetch() {
    await Promise.all([this.fetchActiveUser(), this.getOrgBaseData()])
  },
  computed: {
    activeRouteInfo(): ControlPanelRouteT | undefined {
      if (this.isSubroute) {
        const subRoutes = this.CONTROL_PANELS.find(
          ({ to }) => to === stripTrailingSlash(this.parentRoute ?? '')
        )?.subroutes
        if (subRoutes) {
          return (
            subRoutes.find(({ to }) => to === stripTrailingSlash(this.$route.path)) ||
            this.CONTROL_PANELS.find(({ to }) => to === stripTrailingSlash(this.parentRoute))
          )
        }
      }
      return this.CONTROL_PANELS.find(({ to }) => to === stripTrailingSlash(this.$route.path))
    },
    pageSubroutes(): ControlPanelRouteT[] {
      return (
        this.CONTROL_PANELS.find(({ to }) => to === stripTrailingSlash(this.parentRoute ?? ''))
          ?.subroutes || []
      )
    }
  },
  methods: {
    updateBreadcrumbs() {
      this.reRenderBreadcrumbs = !this.reRenderBreadcrumbs
    }
  }
})
